(function () {
  'use strict';

  angular
    .module('directive.passwordValidator', [])

    /* @ngInject */
    .directive('passwordValidator', function () {
      return {
        require: 'ngModel',
        link: function (_scope, elements, attrs, ngModel) {

          var passwordInput = elements[0];

          var minLength = /.{12,}/;
          var uppercase = /[A-Z]/;
          var lowercase = /[a-z]/;
          var number = /[0-9]/;
          var specialchar = /[!@#$%^&*(),.?":{}|<>-]/;
          var firstOpening = true;

          var passwordRequirementsTitleMessage = attrs.passwordTitleMessage || 'Le mot de passe doit contenir au moins&nbsp;:';
          var passwordRequirements = [
            {
              name: attrs.passwordLengthMessage || '12 caractères',
              valid: minLength
            },
            {
              name: attrs.passwordUppercaseMessage || '1 lettre majuscule',
              valid: uppercase
            },
            {
              name: attrs.passwordLowercaseMessage || '1 lettre minuscule',
              valid: lowercase
            },
            {
              name: attrs.passwordNumberMessage || '1 chiffre',
              valid: number
            },
            {
              name: attrs.passwordSpecialCharMessage || '1 caractère spécial',
              valid: specialchar
            }
          ];

          // Création de la modale
          var passwordRequirementsModal = document.createElement('div');
          passwordRequirementsModal.className = 'password-requirements-modal';
          passwordRequirementsModal.innerHTML = '<div>' + passwordRequirementsTitleMessage + '</div>';
          var passwordRequirementsModalUlTag = document.createElement('ul');
          passwordRequirementsModal.appendChild(passwordRequirementsModalUlTag);

          passwordRequirements.forEach(function (requirement) {
            requirement.element = document.createElement('li');
            requirement.element.innerText = requirement.name;
            passwordRequirementsModalUlTag.appendChild(requirement.element);
          });

          passwordInput.parentNode.insertBefore(passwordRequirementsModal, passwordInput.nextSibling);

          ///// Functions

          function isValidPassword(password) {
            return !passwordRequirements.some(function (requirement) {
              return !requirement.valid.test(password);
            });
          }

          function showPasswordModal(show) {
            if (show && firstOpening) {
              // On aligne la modale avec l'input
              if (passwordInput.offsetLeft > 0) {
                passwordRequirementsModal.style.left = passwordInput.offsetLeft + 'px';
              }
              var positionTop = passwordInput.offsetTop + passwordInput.offsetHeight;
              if (passwordInput.offsetTop > 0) {
                passwordRequirementsModal.style.top = positionTop + 'px';
              }
              firstOpening = false;
            }

            passwordRequirementsModal.style.display = show ? 'block' : 'none';
          }

          function updatePasswordRequirementsModal(password) {
            passwordRequirements.forEach(function (requirement) {
              if (requirement.valid.test(password)) {
                requirement.element.className = 'ok';
              } else {
                requirement.element.className = '';
              }
            });
          }

          function onPasswordInputChange() {
            var passwordValue = passwordInput.value;
            updatePasswordRequirementsModal(passwordValue);
            showPasswordModal(!isValidPassword(passwordValue));
          }

          // On ajoute les événements sur l'input
          passwordInput.addEventListener('focus', function () {
            showPasswordModal(true);
          });
          passwordInput.addEventListener('focusout', function () {
            showPasswordModal(false);
          });
          passwordInput.addEventListener('keyup', function () {
            onPasswordInputChange();
          });
          passwordInput.addEventListener('paste', function () {
            onPasswordInputChange();
          });

          ngModel.$validators.passwordValidator = function (modelValue, viewValue) {
            var value = modelValue || viewValue;
            return isValidPassword(value);
          };
        }
      };
    });
})();
